module.exports = __webpack_public_path__ + "img/delar-refuse.c7864dc1.png";